export interface MenuItem {
  name: string;
  external?: boolean;
  href?: string;
  type?: "group" | "icon";
  children?: MenuItem[];
  img?: string;
}

export const menuItems: MenuItem[] = [
  { name: "Home", href: "/" },
  {
    name: "Testing",
    type: "group",
    children: [
      { name: "Exams & Prep", href: "/exams" },
      { name: "Certification Tracks", href: "/certifications" },
      { name: "Testing Events", href: "/testing-events" },
    ]
  },
  { name: "About", href: "/about" },
  { name: "FAQ's", href: "/faqs" },
  { name: "Links & Downloads", href: "/resources" },
  { name: "Log In", external: true, href: "https://register.evtcc.org" },
  {
    name: "EVTCC on Facebook",
    type: "icon",
    img: "/Facebook_Logo_Primary.png",
    external: true,
    href: "https://www.facebook.com/profile.php?id=100067387294562"
  }
];